module.exports = __webpack_public_path__ + "static/media/play.0265965b.svg";